module.exports = __webpack_public_path__ + "static/media/07-img@3x.5982428a.webp";